import { Period } from 'enums/shared/period';
import { FC } from 'react';

import AppAreaChart from 'presentation/components/shared/chart/AppAreaChart';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import { useTranslation } from 'react-i18next';

interface Props {
  chartData: ChartPoint[];
  currency: Currency;
  chartHeight: number;
  period: Period;
}

const IncomeChartView: FC<Props> = ({
  chartData,
  currency,
  chartHeight,
  period,
}) => {
  const xAxisDateFormats: Record<Period, string> = {
    [Period.Month]: 'L',
    [Period.Month3]: 'L',
    [Period.Month6]: 'MMM',
    [Period.Year]: 'MMM',
    [Period.StartYear]: 'MMM',
    [Period.AllHistory]: 'MMM YYYY',
  };

  const { t } = useTranslation();

  const currencyFormatter = useCurrencyText();

  return (
    <AppAreaChart
      chartData={chartData}
      tooltipFormatter={(value) => {
        return [
          currencyFormatter(+value, { symbol: currency.symbol }),
          t('balance') ?? '',
        ];
      }}
      showXAxis={true}
      showYAxis={true}
      xAxisDateFormat={xAxisDateFormats[period]}
      chartHeight={chartHeight}
    />
  );
};

export default IncomeChartView;
